import { Alert } from "@package/subframe/components/Alert";
import { FeatherLock } from "@subframe/core";

import { ProfileSectionCard } from "./ProfileSectionCard";

export function ConfidentialNote({ text }: { text: string }) {
  return <Alert variant="brand" icon={<FeatherLock />} title={text} />;
}

interface WithheldSectionCardProps {
  title: string;
  testId: string;
}

/** In place of a sensitive section the viewer may not see, so its absence isn't a mystery. */
export function WithheldSectionCard({
  title,
  testId,
}: WithheldSectionCardProps) {
  return (
    <ProfileSectionCard title={title} testId={testId}>
      <div className="flex w-full flex-col items-center gap-1 rounded-md border border-dashed border-neutral-300 bg-neutral-50 px-4 py-6 text-center">
        <span className="text-body-bold font-body-bold text-default-font">
          Not visible to your role
        </span>
        <span className="text-body font-body text-subtext-color">
          Only the employee and their nursery&apos;s Deputy Managers, Managers
          and Group Admins can see this.
        </span>
      </div>
    </ProfileSectionCard>
  );
}
